import clsx from "clsx";

import { getUploadLaterDocsTitle } from "@utils/index";
import { AssetModel } from "@interfaces/index";
import { AlertTriangleSvg } from "@components/index";

export const UploadLaterBannerAssets = ({
  asset,
  className,
}: {
  asset: AssetModel;
  className?: string;
}) =>
  asset.uploadLaterAgreement || asset.uploadLaterInvoice ? (
    <div
      className={clsx(
        "my-4 rounded-xl border border-yellow-40 bg-yellow-200 p-4 md:rounded-lg md:px-4 md:py-3.5",
        className,
      )}
    >
      <div className="flex items-center gap-1 font-bold text-black-100">
        <div className="*:size-5 md:*:size-6">
          <AlertTriangleSvg />
        </div>
        Documents required for this asset
      </div>
      <div className="hidden pt-3 text-black-70 md:block">
        The documents are required to complete your taxfiling for this asset.
        Navigate to Edit Asset for upload.
      </div>
      <div className="pt-3 text-100 text-black-54 md:hidden">
        Upload before tax period submission
      </div>
      <div className="pt-2 text-100 font-bold text-black-70 md:hidden md:pt-3 md:text-200">
        {getUploadLaterDocsTitle(asset)}
      </div>
    </div>
  ) : null;
